export default "__VITE_ASSET__C$q7RuGt__"